import { observer } from 'mobx-react';
import React from 'react';
import BankForm from '../login/banks/BankForm';
import { UI_WEB_API_PATH, View } from '../Routes';
import { getPathByComponent } from '../util/NavigationUtil';
import LaresPostForm from './LaresPostForm';
import qs from 'qs';
import useStores from '../stores/UseStores';

interface ConfirmationHandlerProps {
  component?: string;
  params?: { [key: string]: any };
}

const ConfirmationHandler = observer((props: ConfirmationHandlerProps): React.JSX.Element | null => {
  const { component, params } = props;
  const {
    routeStore: { formForwardParams, route, getParameter },
  } = useStores();

  switch (component) {
    case View.WEB_API:
      route(
        `${UI_WEB_API_PATH}${qs.stringify(
          {
            allowStatisticsCookies: getParameter('allowStatisticsCookies'),
            goto: params?.goto,
          },
          { addQueryPrefix: true },
        )}`,
        true,
      );
      return null;
    case View.MANDATES:
      route(getPathByComponent(component) + (formForwardParams || ''));
      return null;
    case View.BANK_FORM:
      return <BankForm formPostUrl={params?.formPostUrl} redirectData={new Map(Object.entries(params?.redirectData))} />;
    case View.LARES:
      return <LaresPostForm formPostUrl={params?.gotoUrl} lares={params?.lares} />;
    default:
      return null;
  }
});

export default ConfirmationHandler;
